// Map configuration
export const MAP_CONFIG = {
    width: 8192,
    height: 6144,
    pixelsPerMile: 3.2
};

// Continent definitions
export const STATIC_CONTINENTS = [
    {
        id: "western_thirdland",
        name: "Western Thirdland",
        color: "#f39c12", // orange
        points: [
                [
                    3100,
                    1643
                ],
                [
                    3082,
                    1660
                ],
                [
                    3068,
                    1667
                ],
                [
                    3053,
                    1692
                ],
                [
                    3050,
                    1713
                ],
                [
                    3067,
                    1737
                ],
                [
                    3086,
                    1746
                ],
                [
                    3107,
                    1758
                ],
                [
                    3123,
                    1788
                ],
                [
                    3154,
                    1797
                ],
                [
                    3185,
                    1793
                ],
                [
                    3223,
                    1821
                ],
                [
                    3268,
                    1834
                ],
                [
                    3324,
                    1844
                ],
                [
                    3359,
                    1864
                ],
                [
                    3371,
                    1896
                ],
                [
                    3389,
                    1927
                ],
                [
                    3420,
                    1937
                ],
                [
                    3457,
                    1938
                ],
                [
                    3478,
                    1946
                ],
                [
                    3494,
                    1973
                ],
                [
                    3489,
                    1997
                ],
                [
                    3473,
                    2023
                ],
                [
                    3456,
                    2042
                ],
                [
                    3437,
                    2045
                ],
                [
                    3414,
                    2081
                ],
                [
                    3398,
                    2109
                ],
                [
                    3399,
                    2158
                ],
                [
                    3417,
                    2195
                ],
                [
                    3434,
                    2236
                ],
                [
                    3444,
                    2281
                ],
                [
                    3445,
                    2330
                ],
                [
                    3447,
                    2390
                ],
                [
                    3470,
                    2436
                ],
                [
                    3499,
                    2452
                ],
                [
                    3533,
                    2469
                ],
                [
                    3552,
                    2494
                ],
                [
                    3566,
                    2548
                ],
                [
                    3566,
                    2585
                ],
                [
                    3536,
                    2576
                ],
                [
                    3504,
                    2573
                ],
                [
                    3470,
                    2584
                ],
                [
                    3440,
                    2593
                ],
                [
                    3418,
                    2610
                ],
                [
                    3393,
                    2632
                ],
                [
                    3372,
                    2645
                ],
                [
                    3358,
                    2673
                ],
                [
                    3337,
                    2715
                ],
                [
                    3314,
                    2752
                ],
                [
                    3304,
                    2782
                ],
                [
                    3303,
                    2811
                ],
                [
                    3278,
                    2842
                ],
                [
                    3257,
                    2903
                ],
                [
                    3256,
                    2931
                ],
                [
                    3291,
                    2957
                ],
                [
                    3317,
                    2967
                ],
                [
                    3349,
                    2964
                ],
                [
                    3377,
                    2962
                ],
                [
                    3414,
                    2977
                ],
                [
                    3441,
                    3024
                ],
                [
                    3466,
                    3042
                ],
                [
                    3496,
                    3035
                ],
                [
                    3532,
                    3047
                ],
                [
                    3555,
                    3083
                ],
                [
                    3574,
                    3110
                ],
                [
                    3605,
                    3113
                ],
                [
                    3624,
                    3118
                ],
                [
                    3653,
                    3166
                ],
                [
                    3682,
                    3191
                ],
                [
                    3704,
                    3219
                ],
                [
                    3695,
                    3259
                ],
                [
                    3689,
                    3298
                ],
                [
                    3710,
                    3322
                ],
                [
                    3727,
                    3338
                ],
                [
                    3755,
                    3361
                ],
                [
                    3775,
                    3363
                ],
                [
                    3800,
                    3358
                ],
                [
                    3830,
                    3342
                ],
                [
                    3858,
                    3316
                ],
                [
                    3892,
                    3262
                ],
                [
                    3896,
                    3220
                ],
                [
                    3890,
                    3185
                ],
                [
                    3873,
                    3155
                ],
                [
                    3893,
                    3148
                ],
                [
                    3922,
                    3143
                ],
                [
                    3954,
                    3122
                ],
                [
                    3974,
                    3086
                ],
                [
                    3971,
                    3047
                ],
                [
                    3934,
                    2999
                ],
                [
                    3927,
                    2971
                ],
                [
                    3912,
                    2939
                ],
                [
                    3913,
                    2910
                ],
                [
                    3939,
                    2893
                ],
                [
                    3968,
                    2895
                ],
                [
                    4007,
                    2905
                ],
                [
                    4055,
                    2925
                ],
                [
                    4082,
                    2940
                ],
                [
                    4114,
                    2962
                ],
                [
                    4136,
                    2977
                ],
                [
                    4169,
                    2990
                ],
                [
                    4202,
                    3009
                ],
                [
                    4244,
                    3010
                ],
                [
                    4280,
                    3020
                ],
                [
                    4304,
                    3036
                ],
                [
                    4329,
                    3067
                ],
                [
                    4374,
                    3086
                ],
                [
                    4415,
                    3079
                ],
                [
                    4451,
                    3075
                ],
                [
                    4479,
                    3079
                ],
                [
                    4522,
                    3081
                ],
                [
                    4562,
                    3069
                ],
                [
                    4593,
                    3053
                ],
                [
                    4621,
                    3054
                ],
                [
                    4649,
                    3062
                ],
                [
                    4688,
                    3070
                ],
                [
                    4764,
                    3077
                ],
                [
                    4812,
                    3046
                ],
                [
                    4823,
                    2987
                ],
                [
                    4854,
                    2950
                ],
                [
                    4885,
                    2945
                ],
                [
                    4950,
                    2930
                ],
                [
                    4984,
                    2924
                ],
                [
                    5015,
                    2906
                ],
                [
                    5027,
                    2870
                ],
                [
                    5069,
                    2841
                ],
                [
                    5098,
                    2804
                ],
                [
                    5105,
                    2760
                ],
                [
                    5115,
                    2726
                ],
                [
                    5121,
                    2677
                ],
                [
                    5098,
                    2644
                ],
                [
                    5048,
                    2617
                ],
                [
                    5012,
                    2563
                ],
                [
                    4988,
                    2557
                ],
                [
                    4960,
                    2548
                ],
                [
                    4935,
                    2525
                ],
                [
                    4891,
                    2524
                ],
                [
                    4850,
                    2533
                ],
                [
                    4806,
                    2527
                ],
                [
                    4786,
                    2501
                ],
                [
                    4756,
                    2506
                ],
                [
                    4698,
                    2511
                ],
                [
                    4712,
                    2474
                ],
                [
                    4724,
                    2430
                ],
                [
                    4736,
                    2400
                ],
                [
                    4753,
                    2365
                ],
                [
                    4759,
                    2325
                ],
                [
                    4760,
                    2283
                ],
                [
                    4776,
                    2250
                ],
                [
                    4815,
                    2220
                ],
                [
                    4865,
                    2210
                ],
                [
                    4903,
                    2195
                ],
                [
                    4935,
                    2204
                ],
                [
                    4969,
                    2214
                ],
                [
                    5006,
                    2209
                ],
                [
                    5021,
                    2232
                ],
                [
                    5064,
                    2254
                ],
                [
                    5092,
                    2229
                ],
                [
                    5122,
                    2231
                ],
                [
                    5145,
                    2254
                ],
                [
                    5172,
                    2276
                ],
                [
                    5194,
                    2312
                ],
                [
                    5232,
                    2341
                ],
                [
                    5277,
                    2347
                ],
                [
                    5291,
                    2304
                ],
                [
                    5287,
                    2274
                ],
                [
                    5292,
                    2226
                ],
                [
                    5272,
                    2181
                ],
                [
                    5242,
                    2187
                ],
                [
                    5216,
                    2169
                ],
                [
                    5202,
                    2123
                ],
                [
                    5206,
                    2085
                ],
                [
                    5183,
                    2066
                ],
                [
                    5155,
                    2056
                ],
                [
                    5131,
                    2053
                ],
                [
                    5114,
                    2021
                ],
                [
                    5100,
                    1997
                ],
                [
                    5110,
                    1960
                ],
                [
                    5114,
                    1923
                ],
                [
                    5108,
                    1885
                ],
                [
                    5068,
                    1862
                ],
                [
                    5049,
                    1872
                ],
                [
                    5025,
                    1859
                ],
                [
                    5006,
                    1829
                ],
                [
                    4988,
                    1798
                ],
                [
                    5008,
                    1773
                ],
                [
                    5012,
                    1730
                ],
                [
                    4991,
                    1712
                ],
                [
                    5019,
                    1663
                ],
                [
                    5021,
                    1642
                ],
                [
                    5008,
                    1609
                ],
                [
                    4991,
                    1572
                ],
                [
                    4984,
                    1539
                ],
                [
                    4997,
                    1521
                ],
                [
                    5018,
                    1522
                ],
                [
                    5047,
                    1545
                ],
                [
                    5092,
                    1514
                ],
                [
                    5107,
                    1481
                ],
                [
                    5110,
                    1439
                ],
                [
                    5108,
                    1391
                ],
                [
                    5095,
                    1362
                ],
                [
                    5087,
                    1336
                ],
                [
                    5116,
                    1304
                ],
                [
                    5125,
                    1275
                ],
                [
                    5118,
                    1244
                ],
                [
                    5130,
                    1218
                ],
                [
                    5167,
                    1215
                ],
                [
                    5206,
                    1237
                ],
                [
                    5243,
                    1283
                ],
                [
                    5273,
                    1333
                ],
                [
                    5321,
                    1384
                ],
                [
                    5349,
                    1404
                ],
                [
                    5358,
                    1451
                ],
                [
                    5359,
                    1525
                ],
                [
                    5388,
                    1566
                ],
                [
                    5415,
                    1588
                ],
                [
                    5455,
                    1605
                ],
                [
                    5486,
                    1606
                ],
                [
                    5525,
                    1649
                ],
                [
                    5544,
                    1667
                ],
                [
                    5536,
                    1715
                ],
                [
                    5524,
                    1764
                ],
                [
                    5530,
                    1842
                ],
                [
                    5558,
                    1870
                ],
                [
                    5621,
                    1896
                ],
                [
                    5635,
                    1901
                ],
                [
                    5654,
                    1929
                ],
                [
                    5664,
                    1969
                ],
                [
                    5670,
                    2029
                ],
                [
                    5677,
                    2062
                ],
                [
                    5703,
                    2111
                ],
                [
                    5740,
                    2129
                ],
                [
                    5788,
                    2137
                ],
                [
                    5809,
                    2072
                ],
                [
                    5808,
                    2023
                ],
                [
                    5800,
                    1974
                ],
                [
                    5815,
                    1938
                ],
                [
                    5820,
                    1866
                ],
                [
                    5875,
                    1851
                ],
                [
                    5902,
                    1817
                ],
                [
                    5906,
                    1772
                ],
                [
                    5891,
                    1736
                ],
                [
                    5856,
                    1716
                ],
                [
                    5849,
                    1647
                ],
                [
                    5876,
                    1564
                ],
                [
                    5892,
                    1523
                ],
                [
                    5872,
                    1478
                ],
                [
                    5859,
                    1437
                ],
                [
                    5870,
                    1398
                ],
                [
                    5870,
                    1361
                ],
                [
                    5869,
                    1304
                ],
                [
                    5879,
                    1276
                ],
                [
                    5889,
                    1244
                ],
                [
                    5883,
                    1192
                ],
                [
                    5846,
                    1187
                ],
                [
                    5801,
                    1187
                ],
                [
                    5796,
                    1162
                ],
                [
                    5835,
                    1147
                ],
                [
                    5837,
                    1096
                ],
                [
                    5796,
                    1080
                ],
                [
                    5772,
                    1079
                ],
                [
                    5765,
                    1049
                ],
                [
                    5776,
                    997
                ],
                [
                    5758,
                    942
                ],
                [
                    5724,
                    926
                ],
                [
                    5677,
                    911
                ],
                [
                    5647,
                    893
                ],
                [
                    5615,
                    889
                ],
                [
                    5587,
                    893
                ],
                [
                    5567,
                    858
                ],
                [
                    5536,
                    822
                ],
                [
                    5487,
                    816
                ],
                [
                    5455,
                    807
                ],
                [
                    5423,
                    776
                ],
                [
                    5378,
                    745
                ],
                [
                    5335,
                    721
                ],
                [
                    5267,
                    708
                ],
                [
                    5231,
                    697
                ],
                [
                    5200,
                    706
                ],
                [
                    5165,
                    696
                ],
                [
                    5132,
                    669
                ],
                [
                    5092,
                    656
                ],
                [
                    5058,
                    644
                ],
                [
                    5051,
                    628
                ],
                [
                    5011,
                    573
                ],
                [
                    4986,
                    568
                ],
                [
                    4950,
                    603
                ],
                [
                    4916,
                    621
                ],
                [
                    4888,
                    626
                ],
                [
                    4869,
                    604
                ],
                [
                    4854,
                    574
                ],
                [
                    4849,
                    539
                ],
                [
                    4821,
                    509
                ],
                [
                    4811,
                    481
                ],
                [
                    4803,
                    449
                ],
                [
                    4790,
                    415
                ],
                [
                    4752,
                    405
                ],
                [
                    4710,
                    420
                ],
                [
                    4679,
                    463
                ],
                [
                    4680,
                    483
                ],
                [
                    4670,
                    496
                ],
                [
                    4652,
                    522
                ],
                [
                    4632,
                    548
                ],
                [
                    4624,
                    562
                ],
                [
                    4602,
                    568
                ],
                [
                    4563,
                    562
                ],
                [
                    4529,
                    560
                ],
                [
                    4513,
                    591
                ],
                [
                    4509,
                    630
                ],
                [
                    4527,
                    647
                ],
                [
                    4546,
                    675
                ],
                [
                    4541,
                    693
                ],
                [
                    4502,
                    699
                ],
                [
                    4485,
                    728
                ],
                [
                    4477,
                    758
                ],
                [
                    4432,
                    742
                ],
                [
                    4387,
                    733
                ],
                [
                    4360,
                    753
                ],
                [
                    4330,
                    780
                ],
                [
                    4294,
                    781
                ],
                [
                    4273,
                    791
                ],
                [
                    4264,
                    816
                ],
                [
                    4256,
                    856
                ],
                [
                    4250,
                    905
                ],
                [
                    4278,
                    937
                ],
                [
                    4361,
                    980
                ],
                [
                    4402,
                    980
                ],
                [
                    4449,
                    997
                ],
                [
                    4478,
                    1027
                ],
                [
                    4503,
                    1051
                ],
                [
                    4499,
                    1089
                ],
                [
                    4491,
                    1144
                ],
                [
                    4486,
                    1190
                ],
                [
                    4459,
                    1201
                ],
                [
                    4427,
                    1218
                ],
                [
                    4406,
                    1189
                ],
                [
                    4389,
                    1165
                ],
                [
                    4361,
                    1150
                ],
                [
                    4328,
                    1133
                ],
                [
                    4295,
                    1119
                ],
                [
                    4258,
                    1118
                ],
                [
                    4223,
                    1131
                ],
                [
                    4161,
                    1125
                ],
                [
                    4146,
                    1145
                ],
                [
                    4111,
                    1153
                ],
                [
                    4059,
                    1217
                ],
                [
                    4050,
                    1234
                ],
                [
                    4029,
                    1260
                ],
                [
                    3999,
                    1290
                ],
                [
                    3971,
                    1258
                ],
                [
                    3942,
                    1250
                ],
                [
                    3914,
                    1232
                ],
                [
                    3879,
                    1227
                ],
                [
                    3848,
                    1248
                ],
                [
                    3817,
                    1263
                ],
                [
                    3827,
                    1318
                ],
                [
                    3809,
                    1353
                ],
                [
                    3789,
                    1362
                ],
                [
                    3744,
                    1349
                ],
                [
                    3693,
                    1348
                ],
                [
                    3672,
                    1377
                ],
                [
                    3617,
                    1401
                ],
                [
                    3586,
                    1429
                ],
                [
                    3562,
                    1455
                ],
                [
                    3546,
                    1490
                ],
                [
                    3516,
                    1519
                ],
                [
                    3508,
                    1549
                ],
                [
                    3469,
                    1543
                ],
                [
                    3413,
                    1563
                ],
                [
                    3400,
                    1596
                ],
                [
                    3417,
                    1625
                ],
                [
                    3370,
                    1601
                ],
                [
                    3334,
                    1588
                ],
                [
                    3290,
                    1583
                ],
                [
                    3262,
                    1573
                ],
                [
                    3251,
                    1598
                ],
                [
                    3228,
                    1638
                ],
                [
                    3214,
                    1666
                ],
                [
                    3214,
                    1712
                ],
                [
                    3193,
                    1686
                ],
                [
                    3165,
                    1661
                ],
                [
                    3127,
                    1645
                ]
            ]
    },
    {
        id: "eastern_thirdland",
        name: "Eastern Thirdland",
        color: "#2ecc71", // green
        points: [
            [
                3732,
                3391
            ],
            [
                3720,
                3420
            ],
            [
                3728,
                3464
            ],
            [
                3755,
                3476
            ],
            [
                3791,
                3500
            ],
            [
                3820,
                3530
            ],
            [
                3855,
                3566
            ],
            [
                3871,
                3596
            ],
            [
                3877,
                3652
            ],
            [
                3900,
                3703
            ],
            [
                3912,
                3734
            ],
            [
                3885,
                3776
            ],
            [
                3850,
                3786
            ],
            [
                3822,
                3814
            ],
            [
                3772,
                3816
            ],
            [
                3761,
                3779
            ],
            [
                3781,
                3749
            ],
            [
                3800,
                3700
            ],
            [
                3768,
                3667
            ],
            [
                3731,
                3627
            ],
            [
                3693,
                3640
            ],
            [
                3663,
                3669
            ],
            [
                3623,
                3666
            ],
            [
                3563,
                3647
            ],
            [
                3526,
                3644
            ],
            [
                3499,
                3642
            ],
            [
                3459,
                3607
            ],
            [
                3396,
                3591
            ],
            [
                3364,
                3615
            ],
            [
                3333,
                3654
            ],
            [
                3340,
                3717
            ],
            [
                3391,
                3783
            ],
            [
                3438,
                3813
            ],
            [
                3495,
                3818
            ],
            [
                3543,
                3825
            ],
            [
                3589,
                3874
            ],
            [
                3633,
                3913
            ],
            [
                3669,
                3990
            ],
            [
                3710,
                4016
            ],
            [
                3767,
                4056
            ],
            [
                3808,
                4071
            ],
            [
                3867,
                4084
            ],
            [
                3891,
                4132
            ],
            [
                3988,
                4197
            ],
            [
                4055,
                4179
            ],
            [
                4115,
                4157
            ],
            [
                4154,
                4142
            ],
            [
                4181,
                4101
            ],
            [
                4198,
                4155
            ],
            [
                4254,
                4185
            ],
            [
                4375,
                4186
            ],
            [
                4437,
                4175
            ],
            [
                4509,
                4120
            ],
            [
                4568,
                4085
            ],
            [
                4593,
                4075
            ],
            [
                4633,
                4115
            ],
            [
                4712,
                4115
            ],
            [
                4730,
                4026
            ],
            [
                4750,
                3973
            ],
            [
                4767,
                3923
            ],
            [
                4764,
                3881
            ],
            [
                4794,
                3796
            ],
            [
                4770,
                3759
            ],
            [
                4758,
                3702
            ],
            [
                4774,
                3656
            ],
            [
                4798,
                3607
            ],
            [
                4797,
                3555
            ],
            [
                4827,
                3495
            ],
            [
                4827,
                3438
            ],
            [
                4794,
                3402
            ],
            [
                4774,
                3354
            ],
            [
                4805,
                3324
            ],
            [
                4846,
                3293
            ],
            [
                4877,
                3246
            ],
            [
                4872,
                3186
            ],
            [
                4835,
                3133
            ],
            [
                4781,
                3123
            ],
            [
                4736,
                3118
            ],
            [
                4698,
                3120
            ],
            [
                4654,
                3094
            ],
            [
                4615,
                3090
            ],
            [
                4564,
                3087
            ],
            [
                4508,
                3095
            ],
            [
                4454,
                3097
            ],
            [
                4394,
                3098
            ],
            [
                4362,
                3108
            ],
            [
                4320,
                3083
            ],
            [
                4269,
                3057
            ],
            [
                4235,
                3056
            ],
            [
                4201,
                3030
            ],
            [
                4175,
                3009
            ],
            [
                4155,
                2993
            ],
            [
                4124,
                2980
            ],
            [
                4078,
                2959
            ],
            [
                4047,
                2945
            ],
            [
                4019,
                2946
            ],
            [
                3999,
                2973
            ],
            [
                3990,
                3004
            ],
            [
                3998,
                3053
            ],
            [
                4017,
                3080
            ],
            [
                4014,
                3111
            ],
            [
                3990,
                3153
            ],
            [
                3960,
                3174
            ],
            [
                3935,
                3186
            ],
            [
                3931,
                3242
            ],
            [
                3941,
                3268
            ],
            [
                3907,
                3286
            ],
            [
                3880,
                3315
            ],
            [
                3833,
                3344
            ],
            [
                3818,
                3356
            ],
            [
                3798,
                3363
            ],
            [
                3767,
                3367
            ],
            [
                3740,
                3383
            ]]
    },
    {
        id: "dusekara",
        name: "Dusekara",
        color: "#e74c3c", // red
        points: [
            [2061, 690], [2040, 696], [2022, 717], [2000, 710], [1988, 705],
            [1976, 723], [1964, 736], [1944, 743], [1932, 754], [1930, 766],
            [1933, 778], [1937, 795], [1930, 814], [1911, 828], [1903, 841],
            [1917, 851], [1919, 860], [1918, 875], [1909, 886], [1903, 903],
            [1910, 927], [1914, 946], [1929, 948], [1939, 960], [1945, 991],
            [1940, 999], [1933, 1023], [1928, 1043], [1930, 1074], [1950, 1090],
            [1970, 1095], [1984, 1075], [2008, 1071], [2038, 1072], [2054, 1073],
            [2067, 1042], [2087, 1033], [2112, 1021], [2140, 1020], [2158, 1008],
            [2185, 1014], [2203, 1001], [2238, 999], [2265, 1004], [2278, 981],
            [2305, 970], [2332, 985], [2339, 1004], [2328, 1024], [2309, 1031],
            [2301, 1038], [2311, 1066], [2332, 1062], [2356, 1057], [2363, 1064],
            [2360, 1079], [2357, 1088], [2361, 1112], [2369, 1121], [2391, 1116],
            [2395, 1129], [2408, 1146], [2427, 1155], [2454, 1158], [2492, 1156],
            [2523, 1164], [2548, 1165], [2573, 1171], [2587, 1153], [2597, 1132],
            [2595, 1114], [2587, 1094], [2601, 1070], [2622, 1053], [2636, 1040],
            [2654, 1037], [2676, 1034], [2690, 1015], [2697, 979], [2710, 962],
            [2711, 934], [2699, 918], [2697, 905], [2710, 885], [2711, 850],
            [2706, 822], [2691, 812], [2678, 790], [2666, 774], [2653, 759],
            [2643, 739], [2617, 724], [2608, 712], [2595, 698], [2595, 665],
            [2595, 629], [2586, 608], [2575, 608], [2571, 590], [2566, 574],
            [2564, 547], [2545, 552], [2529, 548], [2540, 528], [2540, 502],
            [2522, 496], [2507, 507], [2488, 523], [2479, 536], [2485, 564],
            [2498, 581], [2485, 602], [2475, 618], [2466, 623], [2452, 611],
            [2429, 602], [2415, 602], [2408, 593], [2402, 565], [2412, 545],
            [2415, 531], [2393, 528], [2376, 526], [2358, 521], [2338, 521],
            [2323, 518], [2307, 537], [2282, 552], [2274, 574], [2258, 582],
            [2236, 582], [2223, 584], [2209, 598], [2193, 589], [2179, 589],
            [2170, 597], [2165, 612], [2148, 623], [2129, 629], [2120, 635],
            [2116, 652], [2107, 660], [2101, 671], [2094, 682], [2079, 677],
            [2069, 676]
        ]
    },
    {
        id: "dornai",
        name: "Dornai",
        color: "#3498db", // blue
        points: [
            [
            3026,
            1712
            ],
            [
                3000,
                1678
            ],
            [
                2953,
                1670
            ],
            [
                2911,
                1682
            ],
            [
                2869,
                1716
            ],
            [
                2828,
                1736
            ],
            [
                2778,
                1745
            ],
            [
                2749,
                1781
            ],
            [
                2710,
                1806
            ],
            [
                2669,
                1764
            ],
            [
                2642,
                1731
            ],
            [
                2589,
                1705
            ],
            [
                2510,
                1737
            ],
            [
                2457,
                1730
            ],
            [
                2391,
                1711
            ],
            [
                2254,
                1716
            ],
            [
                2217,
                1758
            ],
            [
                2162,
                1772
            ],
            [
                2128,
                1759
            ],
            [
                2071,
                1730
            ],
            [
                1999,
                1741
            ],
            [
                1964,
                1763
            ],
            [
                1907,
                1772
            ],
            [
                1856,
                1800
            ],
            [
                1799,
                1835
            ],
            [
                1765,
                1871
            ],
            [
                1707,
                1866
            ],
            [
                1651,
                1878
            ],
            [
                1606,
                1941
            ],
            [
                1549,
                1990
            ],
            [
                1523,
                2021
            ],
            [
                1478,
                2033
            ],
            [
                1416,
                2046
            ],
            [
                1364,
                2050
            ],
            [
                1314,
                2103
            ],
            [
                1286,
                2118
            ],
            [
                1223,
                2104
            ],
            [
                1192,
                2126
            ],
            [
                1141,
                2151
            ],
            [
                1098,
                2163
            ],
            [
                1057,
                2205
            ],
            [
                1019,
                2269
            ],
            [
                1005,
                2322
            ],
            [
                1036,
                2372
            ],
            [
                1096,
                2340
            ],
            [
                1128,
                2313
            ],
            [
                1184,
                2308
            ],
            [
                1244,
                2361
            ],
            [
                1314,
                2370
            ],
            [
                1350,
                2341
            ],
            [
                1376,
                2375
            ],
            [
                1422,
                2440
            ],
            [
                1470,
                2500
            ],
            [
                1517,
                2597
            ],
            [
                1586,
                2580
            ],
            [
                1619,
                2540
            ],
            [
                1633,
                2472
            ],
            [
                1686,
                2424
            ],
            [
                1735,
                2377
            ],
            [
                1771,
                2334
            ],
            [
                1825,
                2306
            ],
            [
                1852,
                2349
            ],
            [
                1832,
                2413
            ],
            [
                1831,
                2518
            ],
            [
                1846,
                2576
            ],
            [
                1896,
                2595
            ],
            [
                1961,
                2624
            ],
            [
                1995,
                2671
            ],
            [
                2021,
                2735
            ],
            [
                1981,
                2775
            ],
            [
                1915,
                2796
            ],
            [
                1888,
                2881
            ],
            [
                1892,
                2977
            ],
            [
                1930,
                3011
            ],
            [
                1932,
                3107
            ],
            [
                1988,
                3152
            ],
            [
                2052,
                3168
            ],
            [
                2118,
                3128
            ],
            [
                2219,
                3134
            ],
            [
                2311,
                3177
            ],
            [
                2398,
                3186
            ],
            [
                2538,
                3182
            ],
            [
                2600,
                3156
            ],
            [
                2645,
                3112
            ],
            [
                2716,
                3194
            ],
            [
                2781,
                3274
            ],
            [
                2953,
                3296
            ],
            [
                3037,
                3242
            ],
            [
                3072,
                3173
            ],
            [
                3083,
                3084
            ],
            [
                3113,
                3017
            ],
            [
                3157,
                2965
            ],
            [
                3202,
                2911
            ],
            [
                3235,
                2887
            ],
            [
                3257,
                2841
            ],
            [
                3268,
                2776
            ],
            [
                3290,
                2723
            ],
            [
                3326,
                2688
            ],
            [
                3356,
                2649
            ],
            [
                3396,
                2579
            ],
            [
                3380,
                2519
            ],
            [
                3337,
                2492
            ],
            [
                3283,
                2496
            ],
            [
                3221,
                2507
            ],
            [
                3167,
                2473
            ],
            [
                3119,
                2453
            ],
            [
                3132,
                2400
            ],
            [
                3140,
                2338
            ],
            [
                3144,
                2253
            ],
            [
                3148,
                2190
            ],
            [
                3178,
                2125
            ],
            [
                3194,
                2058
            ],
            [
                3143,
                1987
            ],
            [
                3114,
                1928
            ],
            [
                3079,
                1902
            ],
            [
                3061,
                1846
            ],
            [
                3059,
                1784
            ]]
    },
    {
        id: "eldreth_isles",
        name: "Eldreth Isles",
        color:  "#f1c40f", // yellow
        points: [
            [
                1464,
                3484
            ],
            [
                1462,
                3420
            ],
            [
                1474,
                3358
            ],
            [
                1456,
                3300
            ],
            [
                1404,
                3288
            ],
            [
                1348,
                3306
            ],
            [
                1344,
                3352
            ],
            [
                1296,
                3388
            ],
            [
                1256,
                3394
            ],
            [
                1204,
                3442
            ],
            [
                1170,
                3486
            ],
            [
                1134,
                3516
            ],
            [
                1080,
                3548
            ],
            [
                1048,
                3574
            ],
            [
                1020,
                3650
            ],
            [
                1010,
                3730
            ],
            [
                1016,
                3820
            ],
            [
                1034,
                3892
            ],
            [
                1060,
                3966
            ],
            [
                1100,
                4022
            ],
            [
                1124,
                4066
            ],
            [
                1114,
                4144
            ],
            [
                1054,
                4198
            ],
            [
                1042,
                4272
            ],
            [
                1058,
                4312
            ],
            [
                1054,
                4376
            ],
            [
                1086,
                4432
            ],
            [
                1122,
                4488
            ],
            [
                1154,
                4582
            ],
            [
                1134,
                4664
            ],
            [
                1100,
                4734
            ],
            [
                1076,
                4840
            ],
            [
                1076,
                4914
            ],
            [
                1128,
                5014
            ],
            [
                1166,
                5058
            ],
            [
                1162,
                5104
            ],
            [
                1098,
                5134
            ],
            [
                1018,
                5166
            ],
            [
                956,
                5214
            ],
            [
                894,
                5270
            ],
            [
                838,
                5302
            ],
            [
                818,
                5376
            ],
            [
                828,
                5440
            ],
            [
                848,
                5506
            ],
            [
                838,
                5612
            ],
            [
                846,
                5692
            ],
            [
                896,
                5734
            ],
            [
                994,
                5716
            ],
            [
                1024,
                5664
            ],
            [
                1072,
                5646
            ],
            [
                1132,
                5660
            ],
            [
                1172,
                5692
            ],
            [
                1162,
                5730
            ],
            [
                1206,
                5788
            ],
            [
                1248,
                5784
            ],
            [
                1274,
                5824
            ],
            [
                1318,
                5854
            ],
            [
                1380,
                5874
            ],
            [
                1418,
                5852
            ],
            [
                1476,
                5886
            ],
            [
                1536,
                5912
            ],
            [
                1632,
                5904
            ],
            [
                1688,
                5926
            ],
            [
                1764,
                5926
            ],
            [
                1800,
                5870
            ],
            [
                1794,
                5806
            ],
            [
                1752,
                5756
            ],
            [
                1776,
                5644
            ],
            [
                1806,
                5568
            ],
            [
                1826,
                5516
            ],
            [
                1922,
                5462
            ],
            [
                1978,
                5410
            ],
            [
                2004,
                5360
            ],
            [
                2022,
                5288
            ],
            [
                2068,
                5258
            ],
            [
                2114,
                5202
            ],
            [
                2146,
                5162
            ],
            [
                2174,
                5122
            ],
            [
                2168,
                5042
            ],
            [
                2162,
                4976
            ],
            [
                2146,
                4904
            ],
            [
                2106,
                4866
            ],
            [
                2112,
                4810
            ],
            [
                2060,
                4760
            ],
            [
                1972,
                4766
            ],
            [
                1910,
                4794
            ],
            [
                1872,
                4828
            ],
            [
                1840,
                4826
            ],
            [
                1792,
                4762
            ],
            [
                1756,
                4664
            ],
            [
                1720,
                4632
            ],
            [
                1680,
                4584
            ],
            [
                1660,
                4500
            ],
            [
                1604,
                4424
            ],
            [
                1560,
                4370
            ],
            [
                1584,
                4300
            ],
            [
                1628,
                4248
            ],
            [
                1658,
                4196
            ],
            [
                1642,
                4118
            ],
            [
                1590,
                4096
            ],
            [
                1544,
                4092
            ],
            [
                1528,
                4036
            ],
            [
                1586,
                3974
            ],
            [
                1628,
                3938
            ],
            [
                1682,
                3880
            ],
            [
                1682,
                3806
            ],
            [
                1610,
                3766
            ],
            [
                1558,
                3758
            ],
            [
                1536,
                3728
            ],
            [
                1530,
                3660
            ],
            [
                1510,
                3598
            ],
            [
                1492,
                3542
            ]
        ]
    },
    {
        id: "ostren",
        name: "Ostren",
        color: "#9b59b6", // purple
        points: [
            [
                2418,
                5684
            ],
            [
                2390,
                5756
            ],
            [
                2376,
                5828
            ],
            [
                2352,
                5890
            ],
            [
                2352,
                5954
            ],
            [
                2322,
                6020
            ],
            [
                2252,
                6038
            ],
            [
                2194,
                6092
            ],
            [
                2158,
                6148
            ],
            [
                2112,
                6184
            ],
            [
                2010,
                6242
            ],
            [
                1950,
                6286
            ],
            [
                1904,
                6328
            ],
            [
                1854,
                6372
            ],
            [
                1802,
                6414
            ],
            [
                1772,
                6450
            ],
            [
                1700,
                6492
            ],
            [
                1630,
                6520
            ],
            [
                1554,
                6522
            ],
            [
                1494,
                6516
            ],
            [
                1422,
                6496
            ],
            [
                1364,
                6480
            ],
            [
                1306,
                6472
            ],
            [
                1230,
                6440
            ],
            [
                1196,
                6462
            ],
            [
                1216,
                6586
            ],
            [
                1250,
                6652
            ],
            [
                1300,
                6702
            ],
            [
                1380,
                6742
            ],
            [
                1442,
                6740
            ],
            [
                1512,
                6760
            ],
            [
                1610,
                6770
            ],
            [
                1696,
                6798
            ],
            [
                1772,
                6794
            ],
            [
                1842,
                6818
            ],
            [
                1942,
                6788
            ],
            [
                2014,
                6754
            ],
            [
                2074,
                6778
            ],
            [
                2140,
                6768
            ],
            [
                2206,
                6742
            ],
            [
                2274,
                6736
            ],
            [
                2340,
                6772
            ],
            [
                2362,
                6818
            ],
            [
                2434,
                6872
            ],
            [
                2492,
                6912
            ],
            [
                2542,
                6912
            ],
            [
                2600,
                6944
            ],
            [
                2664,
                6980
            ],
            [
                2730,
                6978
            ],
            [
                2796,
                6942
            ],
            [
                2840,
                6922
            ],
            [
                2820,
                6998
            ],
            [
                2790,
                7048
            ],
            [
                2788,
                7172
            ],
            [
                2804,
                7216
            ],
            [
                2832,
                7334
            ],
            [
                2838,
                7464
            ],
            [
                2870,
                7526
            ],
            [
                2962,
                7528
            ],
            [
                3008,
                7514
            ],
            [
                3050,
                7462
            ],
            [
                3044,
                7392
            ],
            [
                3100,
                7368
            ],
            [
                3128,
                7330
            ],
            [
                3180,
                7298
            ],
            [
                3236,
                7278
            ],
            [
                3238,
                7214
            ],
            [
                3304,
                7242
            ],
            [
                3374,
                7222
            ],
            [
                3430,
                7230
            ],
            [
                3388,
                7282
            ],
            [
                3352,
                7352
            ],
            [
                3334,
                7436
            ],
            [
                3338,
                7494
            ],
            [
                3334,
                7530
            ],
            [
                3286,
                7590
            ],
            [
                3252,
                7618
            ],
            [
                3234,
                7684
            ],
            [
                3244,
                7772
            ],
            [
                3324,
                7814
            ],
            [
                3402,
                7814
            ],
            [
                3468,
                7796
            ],
            [
                3532,
                7766
            ],
            [
                3600,
                7734
            ],
            [
                3674,
                7692
            ],
            [
                3696,
                7714
            ],
            [
                3724,
                7788
            ],
            [
                3746,
                7836
            ],
            [
                3806,
                7882
            ],
            [
                3868,
                7872
            ],
            [
                3920,
                7858
            ],
            [
                3944,
                7824
            ],
            [
                3988,
                7802
            ],
            [
                4010,
                7744
            ],
            [
                4026,
                7706
            ],
            [
                4080,
                7746
            ],
            [
                4136,
                7758
            ],
            [
                4176,
                7774
            ],
            [
                4200,
                7828
            ],
            [
                4244,
                7880
            ],
            [
                4266,
                7926
            ],
            [
                4362,
                7918
            ],
            [
                4412,
                7878
            ],
            [
                4426,
                7802
            ],
            [
                4438,
                7724
            ],
            [
                4480,
                7640
            ],
            [
                4526,
                7594
            ],
            [
                4502,
                7476
            ],
            [
                4448,
                7396
            ],
            [
                4384,
                7382
            ],
            [
                4344,
                7318
            ],
            [
                4352,
                7230
            ],
            [
                4336,
                7116
            ],
            [
                4338,
                7028
            ],
            [
                4398,
                6988
            ],
            [
                4442,
                6938
            ],
            [
                4502,
                6890
            ],
            [
                4502,
                6818
            ],
            [
                4460,
                6766
            ],
            [
                4448,
                6716
            ],
            [
                4508,
                6738
            ],
            [
                4566,
                6754
            ],
            [
                4608,
                6704
            ],
            [
                4668,
                6520
            ],
            [
                4708,
                6478
            ],
            [
                4786,
                6502
            ],
            [
                4906,
                6586
            ],
            [
                4972,
                6562
            ],
            [
                5044,
                6486
            ],
            [
                5094,
                6392
            ],
            [
                5162,
                6310
            ],
            [
                5216,
                6246
            ],
            [
                5254,
                6160
            ],
            [
                5300,
                6008
            ],
            [
                5378,
                5940
            ],
            [
                5418,
                5842
            ],
            [
                5406,
                5762
            ],
            [
                5462,
                5696
            ],
            [
                5474,
                5588
            ],
            [
                5478,
                5496
            ],
            [
                5510,
                5280
            ],
            [
                5558,
                5200
            ],
            [
                5642,
                5106
            ],
            [
                5674,
                5012
            ],
            [
                5700,
                4930
            ],
            [
                5698,
                4830
            ],
            [
                5722,
                4734
            ],
            [
                5778,
                4668
            ],
            [
                5796,
                4606
            ],
            [
                5792,
                4516
            ],
            [
                5730,
                4448
            ],
            [
                5682,
                4402
            ],
            [
                5670,
                4314
            ],
            [
                5660,
                4204
            ],
            [
                5574,
                4216
            ],
            [
                5536,
                4276
            ],
            [
                5482,
                4300
            ],
            [
                5412,
                4286
            ],
            [
                5340,
                4302
            ],
            [
                5294,
                4358
            ],
            [
                5218,
                4368
            ],
            [
                5144,
                4394
            ],
            [
                5090,
                4450
            ],
            [
                5078,
                4530
            ],
            [
                5048,
                4578
            ],
            [
                4998,
                4634
            ],
            [
                4980,
                4692
            ],
            [
                4912,
                4752
            ],
            [
                4836,
                4780
            ],
            [
                4812,
                4886
            ],
            [
                4838,
                4976
            ],
            [
                4932,
                5026
            ],
            [
                5038,
                5048
            ],
            [
                5152,
                5072
            ],
            [
                5220,
                5116
            ],
            [
                5272,
                5178
            ],
            [
                5326,
                5242
            ],
            [
                5288,
                5368
            ],
            [
                5198,
                5462
            ],
            [
                5098,
                5558
            ],
            [
                4994,
                5530
            ],
            [
                4920,
                5468
            ],
            [
                4842,
                5418
            ],
            [
                4718,
                5414
            ],
            [
                4660,
                5494
            ],
            [
                4592,
                5534
            ],
            [
                4562,
                5568
            ],
            [
                4482,
                5564
            ],
            [
                4414,
                5514
            ],
            [
                4418,
                5420
            ],
            [
                4394,
                5292
            ],
            [
                4356,
                5190
            ],
            [
                4286,
                5128
            ],
            [
                4264,
                5090
            ],
            [
                4302,
                4990
            ],
            [
                4266,
                4938
            ],
            [
                4164,
                4900
            ],
            [
                4064,
                4930
            ],
            [
                4008,
                4978
            ],
            [
                3872,
                4942
            ],
            [
                3772,
                4962
            ],
            [
                3748,
                5036
            ],
            [
                3782,
                5100
            ],
            [
                3762,
                5152
            ],
            [
                3748,
                5236
            ],
            [
                3738,
                5324
            ],
            [
                3714,
                5330
            ],
            [
                3678,
                5276
            ],
            [
                3644,
                5208
            ],
            [
                3606,
                5140
            ],
            [
                3552,
                5086
            ],
            [
                3474,
                5086
            ],
            [
                3386,
                5100
            ],
            [
                3310,
                5100
            ],
            [
                3244,
                5108
            ],
            [
                3180,
                5158
            ],
            [
                3150,
                5228
            ],
            [
                3096,
                5282
            ],
            [
                3066,
                5218
            ],
            [
                3028,
                5144
            ],
            [
                2956,
                5110
            ],
            [
                2880,
                5164
            ],
            [
                2796,
                5236
            ],
            [
                2778,
                5314
            ],
            [
                2718,
                5354
            ],
            [
                2676,
                5434
            ],
            [
                2676,
                5492
            ],
            [
                2666,
                5552
            ],
            [
                2644,
                5608
            ],
            [
                2602,
                5644
            ],
            [
                2516,
                5624
            ],
            [
                2452,
                5634
            ]
        ]
    }
];

